import { createRelayResource } from '@townsquare/relay-utils';
import type { ResourceContext } from '@townsquare/router/types';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import { fg } from '@townsquare/stat-sig/gate';
import { TownsquareSiteAri, PlatformSiteAri } from '@atlassian/ari';

import AggGoalViewInnerQuery, {
	type AggGoalViewInnerQuery as AggGoalViewInnerQueryType,
} from '../components/__generated__/AggGoalViewInnerQuery.graphql';

export const createPlatformSiteAri = (siteId: string): string => {
	try {
		return PlatformSiteAri.create({ siteId }).toString();
	} catch {
		// No valid Platform site ari
		throw new Error('No Platform Site Ari');
	}
};

export const aggGoalViewResource = createRelayResource<AggGoalViewInnerQueryType>({
	getQuery: (routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;

		const rawCloudId = context.workspace?.cloudId;

		if (!rawCloudId) throw new Error('No cloudId available');

		const containerId = TownsquareSiteAri.create({ siteId: rawCloudId }).toString();
		const queryContext = createPlatformSiteAri(rawCloudId);

		return {
			query: AggGoalViewInnerQuery,
			// TODO: Make this instead get the @atlassian one, right?
			environment: getAggRelayEnvironment(),
			variables: {
				goalKey: routerContext.match.params.id ?? '',
				containerId: containerId,
				queryContext: queryContext,
				trackViewEvent: 'DIRECT',
				goalUpdateDraftsEnabled: fg('townsquare_goal_update_drafts'),
			},
		};
	},
});
